import { Button, Input, Select } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';  //기본 제공 스타일을 초기화시켜 호환성을 맞춤, 
const { Search } = Input;
export const GlobalStyle = createGlobalStyle`
${reset}
  :root {
      --font-family: 'Suit medium', sans-serif;
    }
  * {
    font-family: var(--font-family);
  }

  body {
    font-family: var(--font-family);
  }
  * {
    padding: 0;
    margin: 0;
    line-height: 100%;
    list-style: none;
  }
  html {
    font-size: 14px;
  }
  body{
    line-height: 22px;
    background-color: #ffffff;
    font-family:'Noto Sans KR',sans-serif;
    padding: 0;
    margin: 0;
    background-color: hsl(0, 0%, 96%);
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  input, button {
    background-color: transparent;
    border: none;
    outline: none;
  }
  h1, h2, h3, h4, h5, h6{
    font-family:'Noto Sans KR ', sans-serif;
  }
  ol, ul, li {
    list-style: none;
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;


export const StyledSelect = styled(Select)<{ type?: string }>`
  font-family: 'Suit medium','Inter medium' ;
  color: rgba(0, 0, 0, 0.87);

  input::placeholder {
    font-family: 'Suit medium','Inter medium' ;
  }

  .ant-select-selector {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }

  .ant-select-selector:hover {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }
  .ant-select-selector:focus {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }

  ${({ theme, type }) => theme.media.monitor(`
    width: ${type === 'search' ? '280px !important' : '100%'};
    height: 40px;
    font-size: 20px;

    .ant-select-selector,
    .ant-select-selection-item,
    .ant-select-selection-placeholder,
    .ant-select-selection-search-input {
      font-size: 20px;
    }

    div {
      font-size: 20px;
    }
  `)}
`;

export const StyledInputSearch = styled(Input)`
font-family: 'Suit medium','Inter medium' ;
color: rgba(0, 0, 0, 0.87);
border-color: #d9d9d9 !important;
box-shadow: none !important;
input {
  font-family: 'Suit medium','Inter medium' ;
  color: rgba(0, 0, 0, 0.87);
}
.ant-input:hover {
  border-color: #d9d9d9 !important;
  box-shadow: none !important;
}
input::placeholder {
  font-family: 'Suit medium','Inter medium' ;
  color: rgba(0, 0, 0, 0.3);
}
${({ theme }) =>
  theme.media.monitor(
  ` 
    font-size: 20px;
    height: 40px;
  `,
)}
`;

export const StyledSearch = styled(Search)`
  font-family: 'Suit medium','Inter medium' ;
  height: 32px !important;
  color: rgba(0, 0, 0, 0.87);
  .ant-input-affix-wrapper{
    height: 32px !important;
  }
  .ant-input {
    font-family: 'Suit medium','Inter medium' ;
  }
  input::placeholder {
    font-family: 'Suit medium','Inter medium' ;
  }
  .ant-input-affix-wrapper:hover {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }
  .ant-input-affix-wrapper:focus-within {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }
  svg {
    color: #5A1EDB !important;
  }
  button:hover {
    border-color: #5A1EDB !important;
    box-shadow: none !important;
  }
  svg:hover {
    color: #5A1EDB !important;
  }
  svg:focus {
    color: #5A1EDB !important;
  }
  ${({ theme }) =>
			theme.media.monitor(
			` 
        font-size: 20px;
			 	width: 460px !important;
        height: 40px !important;
        font-size: 20px;
        .ant-input-affix-wrapper{
          height: 40px !important;
        }
        button{
          height: 40px !important;
        }
        input::placeholder {
          font-size: 20px;
        }
        .ant-input {
          font-size: 20px !important;
          font-family: 'Suit medium','Inter medium' ;
        }
			`,
		)}
`;

export const StyledInput = styled(Input)`
    font-family: 'Suit medium','Inter medium' ;
    color: rgba(0, 0, 0, 0.87);
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
    .ant-input:hover {
      border-color: #d9d9d9 !important;
      box-shadow: none !important;
    }
    input::placeholder {
      font-family: 'Suit medium','Inter medium' ;
      color: rgba(0, 0, 0, 0.87);
    }
    ${({ theme }) =>
      theme.media.monitor(
      ` 
        font-size: 20px;
        height: 40px;
      `,
    )}
`;

export const StyledButton = styled(Button)`
  width: 100%; 
  font-family: 'Suit regular','Inter medium' ;
  color: #ffffff;
  border: none;
  background-color: #5A1EDB;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  &:hover {
    border: none !important;
    box-shadow: none !important;
    color: #ffffff !important;
    background-color: #5A1EDB !important;
  }
  ${({ theme }) =>
      theme.media.monitor(
      ` 
        font-size: 20px;
        height: 40px;
      `,
    )}
`

export const StyledExcelButton = styled(Button)`
  width: 100%; 
  font-family: 'Suit regular','Inter medium' ;
  color: #5A1EDB;
  border: 1px solid #5A1EDB;
  background-color: #ffffff;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  &:hover {
    border: 1px solid #5A1EDB;
    box-shadow: none !important;
    color: #5A1EDB !important;
    border-color: #5A1EDB !important;
  }
  ${({ theme }) =>
      theme.media.monitor(
      ` 
        font-size: 20px;
        height: 40px;
      `,
    )}
`

export const StyledWarning = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.71);
  font-family: 'Suit medium';
  font-size: 16px;
  ${({ theme }) =>
      theme.media.monitor(
      `
        font-size: 32px;
        height: 600px;
      `,
    )}
`;

export const AddStyledButton = styled(Button)`
  margin-left: 8px;
  height: 100%;
  ${({ theme }) =>
    theme.media.monitor(
      `
         height: 86%;
      `,
    )}
`;


export const LanguageToggleButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 50px;
  font-family: 'Suit medium', 'Inter medium';
  font-size: 16px;
  font-weight: 500;
  color: #181A1C;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  z-index: 1000;

  &:hover {
    background: #F8F9FA;
    border-color: #5A27DB;
    box-shadow: 0 4px 12px rgba(90, 39, 219, 0.15);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(90, 39, 219, 0.2);
  }
`;

export const GlobeIcon = styled.span`
  font-size: 20px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LanguageText = styled.span`
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #5A27DB;
`;